/* eslint-disable react/no-unused-prop-types */ import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import React from "react";
import { analytics } from "@silvertours/front-entities";
import { ContentDisplay, LayoutlessDisplay } from "./display";
var isContentPage = function(props) {
    return props.type === "content";
};
var BilligerMietwagenSite = function(_param) {
    var children = _param.children, props = _object_without_properties(_param, [
        "children"
    ]);
    analytics.gtm.usePageView();
    analytics.gtm.useReportWebVitals();
    return isContentPage(props) ? /*#__PURE__*/ _jsx(ContentDisplay, _object_spread_props(_object_spread({}, props), {
        children: children
    })) : /*#__PURE__*/ _jsx(LayoutlessDisplay, _object_spread_props(_object_spread({}, props), {
        children: children
    }));
};
export { BilligerMietwagenSite };
